import {ModelGroup} from '../../model-group/model-group.model';

export class ModelCode {
  id: number;
  validFrom: string = this.getFirstDayOfYear();
  validTo: string = this.getLastDayOfYear();
  modelCode: string;
  factor: number;
  extendedFactor: number;
  description: string;
  modelGroup: ModelGroup;

  getFirstDayOfYear() {
    const m = new Date(new Date().getFullYear(), 0, 1);
    return m.getFullYear() + '-' + m.getMonth() + 1 + '-' + this.addZero(m.getDate());
  }

  getLastDayOfYear() {
    const m = new Date(new Date().getFullYear(), 11, 31);
    return m.getFullYear() + '-' + (Number(m.getMonth()) + 1) + '-' + m.getDate();
  }

  addZero(n: number) {
    if (n < 10) {
      return '0' + n;
    } else {
      return n;
    }
  }
}
